// @flow

import getGoogleDriveVideoURL from './getGoogleDriveVideoURL';

export default function getProviderVideoURL(url?: ?string): ?string {
  return getGoogleDriveVideoURL(url) ?? url;
}
